import {AfterViewInit, Component, EventEmitter, Input, NgZone, Output} from "@angular/core";
import {CellActivationMode, EditGridService} from "../edit-grid.service";
import {take} from "rxjs";

export class CellActivationEvent {
    cellActivationMode: CellActivationMode;
    activationAllowed: boolean = true;

    constructor(cellActivationMode: CellActivationMode) {
        this.cellActivationMode = cellActivationMode;
    }
}

@Component({
    selector: "wbo-edit-grid-cell-activator",
    template: ""
})
export class EditGridCellActivatorComponent implements AfterViewInit {
    @Input() columnIndex: number;
    @Input() editControl: any;
    @Input() select: boolean;

    /**
     * Event for cell activation events
     * @type {EventEmitter}
     */
    @Output() activate: EventEmitter<CellActivationEvent> = new EventEmitter<CellActivationEvent>();

    constructor(private editGridService: EditGridService, private ngZone: NgZone) {
        this.editGridService.columnFocus$.subscribe(columnIndex => {
            if (columnIndex === this.columnIndex && this.editControl.focus) {
                this.editControl.focus();
                if (this.select) {
                    this.editControl.select();
                }
            }
        })
    }

    ngAfterViewInit(): void {
        if (this.editGridService.editingColumnIndex === this.columnIndex && this.editGridService.cellActivationMode !== undefined) {
            const activationEvent: CellActivationEvent = new CellActivationEvent(this.editGridService.cellActivationMode);
            this.activate.emit(activationEvent);
            if (activationEvent.activationAllowed) {
                if (this.editControl) {
                    const editControl = this.editControl;
                    if (this.editGridService.cellActivationMode === CellActivationMode.FOCUS && editControl.focus) {
                        this.ngZone.runOutsideAngular(() => this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
                            editControl.focus();
                            if (this.select) {
                                this.editControl.select();
                            }
                        }));
                    } else if (this.editGridService.cellActivationMode === CellActivationMode.CLICK && editControl.click) {
                        this.ngZone.runOutsideAngular(() => this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
                            if (editControl.focus) {
                                editControl.focus();
                            }
                            editControl.click();
                            if (this.select) {
                                this.editControl.select();
                            }
                        }));
                    }
                }
                this.editGridService.clearCellActivation();
            }
        }
    }
}
